<template>
  <div class="container">
  <ol class="breadcrumb">
    <li><router-link :to="{ name: 'dashboard' }">Dashboard</router-link></li>
    <li class="active">Admin - Users</li>
  </ol>

  <div class="row">
    <div class="col-xs-6">
      <router-link :to="{ name: 'adminUser', params: { id: 0 }}">
        <button type="button" class="btn btn-primary" aria-label="Left Align">
          Create User
        </button>
      </router-link>
    </div>
    <div class="col-xs-6">
      <form class="form-inline">
        <div class="form-group has-feedback">
          <input v-model="searchTerm" type="text" class="form-control" id="inputSearch" placeholder="search..." aria-describedby="inputSearchStatus">
          <!-- <span v-if="searchTerm" v-on:click="clearSearchTerm" class="glyphicon glyphicon-remove-circle form-control-feedback" aria-hidden="true"></span>
          <span id="inputSearchStatus" class="sr-only">(clear)</span> -->
        </div>
      </form>



      <!-- <form class="form-inline">
        <div class="form-group has-feedback">
          <input v-model="searchTerm" class="form-control" type="search" placeholder="search">
          <button type="button" class="btn btn-default btn-sm" aria-label="Left Align">
            Clear
          </button>
        </div>
      </div>
    </form> -->
  </div>
</div>

<div class="row">
  <div class="col-sm-12">
    <div class="responsive-table">
      <table class="table">
        <thead>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          <td></th>
          </thead>
          <tbody>
            <tr v-for="user in sortedUsers">
              <td>{{ user.first_name }}</td>
              <td>{{ user.last_name }}</td>
              <td>{{ user.email }}</td>
              <td>
                <router-link :to="{ name: 'adminUser', params: { id: user.id }}">
                <button type="button" class="btn btn-default btn-sm" aria-label="Left Align">
                  <span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                </button>
              </router-link>
                <button type="button" class="btn btn-default btn-sm" aria-label="Left Align">
                  <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</template>

<style scoped>
</style>

<script>
import _ from 'underscore'

export default {
  data () {
    return {
      users: [],
      searchTerm: ''
    }
  },

  computed: {
    sortedUsers () {
      return _.sortBy(this.users, 'last_name')
    }
  },

  methods: {
    clearSearchTerm () {
      this.searchTerm = ''
    },
    fetch () {
      this.$apiAdmin.fetchUsers()
      .then((users) => {
        this.users = users
      })
      .catch((error) => {
        console.log('admin users fetch error', error)
      })
    }
  },

  mounted () {
    this.fetch()
  }
}
</script>



// WEBPACK FOOTER //
// AdminUsers.vue?7dec6808